<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div>
    <app-pageheader [Parent]="this">
      <button class="button is-light" (click)="viewHistory()" [disabled]="busy || communicationBusy">
        <span class="icon"><i class="fas fa-history"></i></span>
        <span>View History</span>
      </button>
      <button class="button is-light" (click)="refreshAppeal()" [disabled]="busy || communicationBusy">
        <span class="icon"><i class="fas fa-sync-alt"></i></span>
        <span>Refresh</span>
      </button>
    </app-pageheader>
    <div class="columns is-multiline appeal-layout">
      <!-- Appeal Overview - 2/3 width with appeal details and user reason/description -->
      <div class="column is-8">
        <article class="panel">
          <p class="panel-heading">Appeal Overview</p>
          <div class="panel-block">
            <span class="label">Status</span>
            <span class="value">
              <span class="tag" [ngClass]="{'is-warning': !Model.IsUpheld && !Model.IsDenied, 'is-success': Model.IsUpheld, 'is-danger': Model.IsDenied}">
                {{formatStatus(Model.Status)}}
              </span>
            </span>
          </div>
          <div class="panel-block">
            <span class="label">Submitted</span>
            <span class="value">{{Model.SubmissionDateLocalFriendlyString}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Contact</span>
            <span class="value" [ngClass]="{'has-text-grey is-italic': !Model.EmailAddress}">{{Model.EmailAddress || 'N/A'}}</span>
          </div>
          <div class="panel-block appeal-reason-block">
            <span class="label">Appeal Reason</span>
            <span class="value appeal-reason-value" [ngClass]="{'has-text-grey is-italic': !Model.ReasonText}">{{Model.ReasonText || 'No reason provided'}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Decision Date</span>
            <span class="value" [ngClass]="{'has-text-grey is-italic': !Model.DecisionDateLocalFriendlyString && !Model.DecisionDate}">
              {{Model.DecisionDateLocalFriendlyString || (Model.DecisionDate | date:'medium') || 'Pending'}}
            </span>
          </div>
          @if (Model.DecisionByUserName) {
            <div class="panel-block">
              <span class="label">Decision By</span>
              <span class="value">{{Model.DecisionByUserName}}</span>
            </div>
          }
          @if (Model.DecisionText) {
            <div class="panel-block decision-text-block">
              <span class="label">Decision Notes</span>
              <span class="value decision-text-value">{{Model.DecisionText}}</span>
            </div>
          }
          <!-- Communications section (if any) -->
          @if (Model.Communications?.length) {
            <div class="panel-block is-block communications-block">
              <p class="label mb-2">Communications</p>
              <div class="timeline">
                @for (communication of Model.Communications; track communication) {
                  <div class="timeline-item">
                    <p class="heading">{{communication.SentDateLocalFriendlyString}} • {{communication.SenderName || 'System'}}</p>
                    <p>{{communication.Message}}</p>
                  </div>
                }
              </div>
            </div>
          }
        </article>
      </div>
      <!-- Citation Summary - 1/3 width -->
      <div class="column is-4">
        <article class="panel citation-summary-panel">
          <p class="panel-heading">Citation Summary</p>
          @if (Citation) {
            <div class="panel-block is-block">
              <dl class="citation-data-list">
                <div class="citation-data-row">
                  <dt>Notice #</dt>
                  <dd>
                    <a [routerLink]="['/enforcement/citations/issued', Model.CitationId]" class="has-text-link">
                      {{Model.CitationId}}
                    </a>
                  </dd>
                </div>
                <div class="citation-data-row">
                  <dt>Issued</dt>
                  <dd>{{Citation.IssuedDateLocalFriendlyString}}</dd>
                </div>
                @if (Citation.ParkingSpaceName) {
                  <div class="citation-data-row">
                    <dt>Location</dt>
                    <dd>{{Citation.ParkingSpaceName}}</dd>
                  </div>
                }
                @if (Citation.ViolationId) {
                  <div class="citation-data-row">
                    <dt>Violation</dt>
                    <dd>
                      <a [routerLink]="['/enforcement/violations', Citation.ViolationId]" class="has-text-link">
                        #{{Citation.ViolationId}}
                      </a>
                    </dd>
                  </div>
                }
                @if (Citation.Infringements?.length) {
                  <div class="citation-data-row">
                    <dt>Infringements</dt>
                    <dd>
                      <ul class="infringement-list">
                        @for (infr of Citation.Infringements; track infr) {
                          <li>
                            {{infr.InfringementTypeName || ('#' + infr.InfringementTypeId)}} - {{infr.CurrentPrice | currency}}
                          </li>
                        }
                      </ul>
                    </dd>
                  </div>
                }
              </dl>
            </div>
          } @else {
            <div class="panel-block has-text-grey is-italic">
              Citation details not available.
            </div>
          }
        </article>
      </div>
      <!-- Media - Full width row -->
      <div class="column is-12">
        <article class="panel">
          <p class="panel-heading">Appeal Media</p>
          <div class="panel-block is-block">
            @if (Model.Media?.length) {
              <p class="mt-1 has-text-grey is-size-7">
                {{Model.Media.length}} file{{Model.Media.length === 1 ? '' : 's'}} attached to this appeal.
                Click a file to view or download.
              </p>
              <div class="appeal-media-grid mt-3">
                @for (media of Model.Media; track media) {
                  <button
                    type="button"
                    class="appeal-media-item"
                    (click)="openMedia(media)">
                    <div class="appeal-media-thumb">
                      @if (mediaPreviews[media.MediaId]?.isImage && !mediaImageErrors[media.MediaId]) {
                        <img
                          [src]="mediaPreviews[media.MediaId]?.dataUrl"
                          [alt]="mediaPreviews[media.MediaId]?.name || ('Media #' + media.MediaId)"
                          (error)="onMediaImageError(media.MediaId)" />
                        } @else {
                          <div class="appeal-media-icon">
                            <span class="icon is-large">
                              <i [ngClass]="getMediaIconClass(media.MediaId)"></i>
                            </span>
                          </div>
                        }
                      </div>
                      <div class="appeal-media-meta">
                        <div class="appeal-media-name">
                          {{mediaPreviews[media.MediaId]?.name || ('Media #' + media.MediaId)}}
                        </div>
                      </div>
                    </button>
                  }
                </div>
              } @else {
                <p>No media has been attached to this appeal.</p>
              }
            </div>
          </article>
        </div>
        <!-- Decision / Workflow -->
        <div class="column is-12">
          <article class="panel decision-panel">
            <p class="panel-heading">
              Decision &amp; Workflow
              @if (!Model.IsUpheld && !Model.IsDenied) {
                <span class="tag is-warning is-light is-rounded ml-2 is-uppercase is-size-7 has-text-weight-semibold">
                  What outcome should this appeal have?
                </span>
              }
              @if (Model.IsUpheld) {
                <span class="tag is-success is-light is-rounded ml-2 is-uppercase is-size-7 has-text-weight-semibold">
                  Appeal Upheld
                </span>
              }
              @if (Model.IsDenied) {
                <span class="tag is-danger is-light is-rounded ml-2 is-uppercase is-size-7 has-text-weight-semibold">
                  Appeal Denied
                </span>
              }
            </p>
            <div class="panel-block is-block">
              <!-- No decision made yet - show decision form -->
              @if (!Model.IsUpheld && !Model.IsDenied) {
                <form [formGroup]="decisionForm" (ngSubmit)="submitDecision()">
                  <p class="decision-intro">
                    Choose the final outcome for this appeal and record clear notes explaining why. These notes may be
                    referenced later when reviewing decisions.
                  </p>
                  <!-- Decision Type Selection -->
                  <div class="field is-horizontal mt-4">
                    <div class="field-label is-normal">
                      <label class="label">Decision</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <label class="radio">
                            <input type="radio" [value]="true" formControlName="isUpheld">
                            <span class="ml-2">Uphold Appeal</span>
                          </label>
                        </div>
                        <div class="control mt-2">
                          <label class="radio">
                            <input type="radio" [value]="false" formControlName="isUpheld">
                            <span class="ml-2">Deny Appeal</span>
                            <span class="has-text-grey is-size-7 ml-1">(infringement remains)</span>
                          </label>
                        </div>
                        @if (decisionForm.controls.isUpheld.errors?.['required']) {
                          <span class="has-text-danger"> You must select a decision </span>
                        }
                      </div>
                    </div>
                  </div>
                  <!-- Uphold options -->
                  @if (decisionForm.controls.isUpheld.value) {
                    <div class="box ml-5 mt-3">
                      <div class="field is-horizontal">
                        <div class="field-label is-normal">
                          <label class="label">Action</label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <div class="control">
                              <label class="radio">
                                <input type="radio" [value]="false" formControlName="withAdjustments">
                                <span class="ml-2">Void Infringement</span>
                              </label>
                            </div>
                            <div class="control mt-2">
                              <label class="radio">
                                <input type="radio" [value]="true" formControlName="withAdjustments">
                                <span class="ml-2">Reduce Fee</span>
                              </label>
                            </div>
                            @if (decisionForm.controls.withAdjustments.errors?.['withAdjustments']) {
                              <span class="has-text-danger">
                                {{ decisionForm.controls.withAdjustments.errors?.['withAdjustments'] }}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                      <!-- Void Infringement options -->
                      @if (decisionForm.controls.withAdjustments.value === false) {
                        <div class="box ml-5 mt-3">
                          <div class="field is-horizontal">
                            <div class="field-label is-normal">
                              <label class="label">Void Reason <span class="has-text-danger">*</span></label>
                            </div>
                            <div class="field-body">
                              <div class="field">
                                <div class="control">
                                  <div class="select is-fullwidth">
                                    <select formControlName="selectedVoidReasonId">
                                      <option [ngValue]="null">-- Select a void reason --</option>
                                      @for (reason of voidReasons; track reason) {
                                        <option [ngValue]="reason.Id">
                                          {{reason.Text}}
                                        </option>
                                      }
                                    </select>
                                  </div>
                                </div>
                                <p class="help">The infringement will be voided with this reason when the appeal is upheld.</p>
                                @if (decisionForm.controls.selectedVoidReasonId.errors?.['selectedVoidReasonId']) {
                                  <span class="has-text-danger">
                                    {{ decisionForm.controls.selectedVoidReasonId.errors?.['selectedVoidReasonId'] }}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      <!-- Reduce Fee options -->
                      @if (decisionForm.controls.withAdjustments.value) {
                        <div class="box ml-5 mt-3">
                          <div class="field is-horizontal">
                            <div class="field-label is-normal">
                              <label class="label">Set Infringement Fee To ($) <span class="has-text-danger">*</span></label>
                            </div>
                            <div class="field-body">
                              <div class="field">
                                <div class="control">
                                  <input type="number" class="input" formControlName="adjustmentAmount" min="0" step="0.01">
                                </div>
                                @if (decisionForm.controls.adjustmentAmount.errors?.['adjustmentAmount']) {
                                  <span class="has-text-danger">
                                    {{ decisionForm.controls.adjustmentAmount.errors?.['adjustmentAmount'] }}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="field is-horizontal mt-3">
                            <div class="field-label is-normal">
                              <label class="label">Adjustment Reason <span class="has-text-danger">*</span></label>
                            </div>
                            <div class="field-body">
                              <div class="field">
                                <div class="control">
                                  <textarea class="textarea" rows="3" formControlName="adjustmentReason" maxlength="512"
                                  placeholder="Explain the reasoning behind the discount..."></textarea>
                                </div>
                                @if (decisionForm.controls.adjustmentReason.errors?.['adjustmentReason']) {
                                  <span class="has-text-danger">
                                    {{ decisionForm.controls.adjustmentReason.errors?.['adjustmentReason'] }}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="field is-horizontal mt-3">
                            <div class="field-label"></div>
                            <div class="field-body">
                              <div class="field">
                                <label class="checkbox">
                                  <input type="checkbox" formControlName="freezeAfterAdjustment">
                                  <span class="ml-2">Freeze Escalation Schedule</span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <!-- Freeze options -->
                          @if (decisionForm.controls.freezeAfterAdjustment.value) {
                            <div class="box ml-5 mt-3">
                              <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                  <label class="label">Freeze Reason <span class="has-text-danger">*</span></label>
                                </div>
                                <div class="field-body">
                                  <div class="field">
                                    <div class="control">
                                      <textarea class="textarea" rows="3" maxlength="512" formControlName="freezeReason"
                                      placeholder="Explain the reasoning behind the payment freeze..."></textarea>
                                    </div>
                                    @if (decisionForm.controls.freezeReason.errors?.['freezeReason']) {
                                      <span class="has-text-danger">
                                        {{ decisionForm.controls.freezeReason.errors?.['freezeReason'] }}
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div class="field is-horizontal mt-3">
                                <div class="field-label"></div>
                                <div class="field-body">
                                  <div class="field">
                                    <label class="checkbox">
                                      <input type="checkbox" formControlName="freezeIndefinitely">
                                      <span class="ml-2">Freeze Indefinitely</span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                              @if (!decisionForm.controls.freezeIndefinitely.value) {
                                <div class="field is-horizontal mt-3">
                                  <div class="field-label is-normal">
                                    <label class="label">Freeze End Date <span class="has-text-danger">*</span></label>
                                  </div>
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control has-icons-left">
                                        <input type="date" class="input" formControlName="freezeUntil">
                                        <span class="icon is-small is-left">
                                          <i class="fas fa-calendar-alt"></i>
                                        </span>
                                      </div>
                                      @if (decisionForm.controls.freezeUntil.errors?.['freezeUntil']) {
                                        <span class="has-text-danger">
                                          {{ decisionForm.controls.freezeUntil.errors?.['freezeUntil'] }}
                                        </span>
                                      }
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  <!-- Decision Notes (always visible) -->
                  <div class="field is-horizontal mt-4">
                    <div class="field-label is-normal">
                      <label class="label">Decision Notes <span class="has-text-danger">*</span></label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <textarea class="textarea" rows="3" maxlength="4000" formControlName="decisionNotes"
                          placeholder="Explain the reasoning behind your decision..."></textarea>
                        </div>
                        @if (decisionForm.controls.decisionNotes.errors?.['required']) {
                          <span class="has-text-danger">
                            Decision Notes are required
                          </span>
                        }
                        @if (decisionForm.controls.decisionNotes.errors?.['maxlength']) {
                          <span class="has-text-danger">
                            Decision Notes can be at most 4000 characters long.
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                  <!-- Evidence Images Upload -->
                  <div class="field is-horizontal mt-4">
                    <div class="field-label is-normal">
                      <label class="label"><i class="fas fa-camera"></i>Evidence Images</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="file-drop-zone"
                          [class.is-dragging]="isDragging"
                          (dragover)="onDragOver($event)"
                          (dragleave)="onDragLeave($event)"
                          (drop)="onDrop($event)">
                          <div class="file-drop-content">
                            <span class="icon is-large has-text-grey-light">
                              <i class="fas fa-cloud-upload-alt fa-3x"></i>
                            </span>
                            <p class="mt-2">Drag and drop images here</p>
                            <p class="has-text-grey is-size-7">or</p>
                            <div class="file is-info is-boxed mt-2">
                              <label class="file-label">
                                <input class="file-input" type="file" accept="image/*" multiple (change)="onFileSelected($event)" />
                                <span class="file-cta">
                                  <span class="file-icon">
                                    <i class="fas fa-upload"></i>
                                  </span>
                                  <span class="file-label">Choose files</span>
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        @if (uploadingFile) {
                          <div class="has-text-centered mt-3">
                            <span class="icon"><i class="fas fa-spinner fa-spin"></i></span>
                            <span>Uploading...</span>
                          </div>
                        }
                        @if (uploadedMediaIds.length > 0) {
                          <div class="mt-3">
                            <p class="has-text-grey is-size-7 mb-2">Uploaded images:</p>
                            <div class="tags">
                              @for (mediaId of uploadedMediaIds; track mediaId; let i = $index) {
                                <span class="tag is-info is-medium">
                                  <span class="icon"><i class="fas fa-image"></i></span>
                                  <span>Image #{{ i + 1 }}</span>
                                  <button class="delete is-small" type="button" (click)="removeMedia(i)" [attr.aria-label]="'Remove uploaded image #' + (i + 1)"></button>
                                </span>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <!-- Submit Button -->
                  <div class="buttons workflow-actions mt-3">
                    <button class="button is-primary" [disabled]="busy || uploadingFile || decisionForm.invalid">
                      <span class="icon"><i class="fas fa-gavel"></i></span>
                      <span>Submit Decision</span>
                    </button>
                  </div>
                </form>
              }
              <!-- Decision already made - show option to return to review -->
              @if (Model.IsUpheld || Model.IsDenied) {
                <div class="notification is-light" [ngClass]="{'is-success': Model.IsUpheld, 'is-danger': Model.IsDenied}">
                  <p class="has-text-weight-semibold mb-2">
                    <span class="icon"><i class="fas" [ngClass]="{'fa-check-circle': Model.IsUpheld, 'fa-times-circle': Model.IsDenied}"></i></span>
                    This appeal has been {{ Model.IsUpheld ? 'upheld' : 'denied' }}.
                  </p>
                  @if (Model.DecisionText) {
                    <p class="is-size-7">
                      <strong>Decision Notes:</strong> {{ Model.DecisionText }}
                    </p>
                  }
                  @if (Model.DecisionDateLocalFriendlyString) {
                    <p class="is-size-7 has-text-grey mt-1">
                      Decided {{ Model.DecisionDateLocalFriendlyString }}
                      @if (Model.DecisionByUserName) {
                        <span> by {{ Model.DecisionByUserName }}</span>
                      }
                    </p>
                  }
                  <!-- Decision Media -->
                  <div class="mt-3">
                    <div class="box">
                      <p class="has-text-weight-semibold mb-2">Decision Media:</p>
                      @if (Model.DecisionMedia?.length) {
                        <p class="has-text-grey is-size-7 mb-2">
                          {{Model.DecisionMedia.length}} file{{Model.DecisionMedia.length === 1 ? '' : 's'}} attached to this appeal decision.
                          Click a file to view or download.
                        </p>
                        <div class="appeal-media-grid">
                          @for (media of Model.DecisionMedia; track media) {
                            <button
                              type="button"
                              class="appeal-media-item"
                              (click)="openMedia(media)">
                              <div class="appeal-media-thumb">
                                @if (mediaPreviews[media.MediaId]?.isImage && !mediaImageErrors[media.MediaId]) {
                                  <img
                                    [src]="mediaPreviews[media.MediaId]?.dataUrl"
                                    [alt]="mediaPreviews[media.MediaId]?.name || ('Media #' + media.MediaId)"
                                    (error)="onMediaImageError(media.MediaId)" />
                                  } @else {
                                    <div class="appeal-media-icon">
                                      <span class="icon is-large">
                                        <i [ngClass]="getMediaIconClass(media.MediaId)"></i>
                                      </span>
                                    </div>
                                  }
                                </div>
                                <div class="appeal-media-meta">
                                  <div class="appeal-media-name">
                                    {{mediaPreviews[media.MediaId]?.name || ('Media #' + media.MediaId)}}
                                  </div>
                                </div>
                              </button>
                            }
                          </div>
                        } @else {
                          <p class="is-size-7 has-text-grey is-italic">No media has been attached to this appeal decision.</p>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="buttons workflow-actions mt-3">
                    <button class="button is-warning" (click)="undoDecision()" [disabled]="busy">
                      <span class="icon"><i class="fas fa-undo"></i></span>
                      <span>Undo Decision &amp; Return to Review</span>
                    </button>
                  </div>
                  <p class="help has-text-grey mt-2">
                    <span class="icon is-small"><i class="fas fa-exclamation-triangle"></i></span>
                    Undoing the decision will clear the current outcome and allow a new decision to be made.
                  </p>
                }
              </div>
            </article>
          </div>
          <!-- Notes - Full Width at Bottom -->
          <div class="column is-12">
            <article class="panel">
              <div class="panel-heading">
                <div class="level is-mobile">
                  <div class="level-left">
                    <div class="level-item">
                      <span class="icon mr-2"><i class="fas fa-sticky-note"></i></span>
                      Notes
                    </div>
                  </div>
                  <div class="level-right">
                    <button class="button is-primary is-small" (click)="addNote()" [disabled]="noteBusy">
                      <span class="icon"><i class="fas fa-plus"></i></span>
                      <span>Add Note</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="panel-block is-block">
                @if (Model.Notes?.length) {
                  <div class="notes-list">
                    @for (note of Model.Notes; track note) {
                      <div class="note-item">
                        <div class="note-header">
                          <span class="note-date">{{note.CreatedDateLocalFriendlyString}}</span>
                          <span class="note-author">{{note.CreatedByUserName || 'Unknown User'}}</span>
                        </div>
                        <div class="note-content">{{note.Content}}</div>
                      </div>
                    }
                  </div>
                }
                @if (!Model.Notes?.length) {
                  <div class="has-text-centered has-text-grey py-4">
                    <span class="icon is-medium"><i class="fas fa-sticky-note"></i></span>
                    <p class="mt-2">No notes have been added to this appeal.</p>
                  </div>
                }
              </div>
            </article>
          </div>
        </div>
      </div>
    }
